import React, { useEffect } from "react";
import styles from "./characteristicCustomForm.module.scss";
import { TextField } from "../../primary";
import constants from "../../../constants/constants.json";

export function CharacteristicCustomFormText({ data, index, getForm, register, errors, setValue, clearErrors, getTextBoxVal, onAnswerChange }) {
  const viewForm = getForm?.formdata?.find((v) => v.id === data.id);

  useEffect(() => {
    register(`${data.id}`, {
        required: data?.isMandatory === 1 ? constants.customForm.responseIsRequired : false,
      });
      
    if (viewForm?.value !== undefined) {
      setValue(`${data.id}`, viewForm?.value, {
        shouldValidate: true,
        shouldDirty: true,
      });
    }
  }, [viewForm?.value, data.id, setValue, register, data?.isMandatory]);

  const handleTextBoxValue = (e) => {
    const value = e.target.value;
    const formData = getForm?.formdata ?? [];

    const selectedIndex = formData.findIndex((x) => x.id === data?.id);
    const viewForm = selectedIndex !== -1 ? formData[selectedIndex] : null;

    if (viewForm) {
      const updatedForm = [...formData];
      updatedForm[selectedIndex] = { ...viewForm, value };
      getTextBoxVal({ ...getForm, formdata: updatedForm });
    } else {
      getTextBoxVal({ ...getForm, formdata: [...formData, { id: data.id, options: null, value }] });
    }

    setValue(`${data.id}`, value, { shouldValidate: true, shouldDirty: true });
    clearErrors(`${data.id}`);
    onAnswerChange();
  };

  return (
    <TextField
      id={`${data.id}`}
      name={`${data.id}`}
      label={`${data.desc}`}
      classes={{
        column: `row ${styles.col_spec}`,
        labelClass: `col-6 col-form-label ${styles.label_spec}`,
        inputColumn: `col-5 p-0 d-flex flex-column`,
        inputClassName: `${styles.basic_input} getTextBox`,
      }}
      type="text"
      validator={register(`${data.id}`, {
        required: data?.isMandatory === 1 ? constants.customForm.responseIsRequired : false,
      })}
      errors={errors}
      defaultValue={viewForm?.value || ""}
      key={index}
      onBlur={handleTextBoxValue}
      placeholder={data.placeholder}
      required={data?.isMandatory === 1}
    />
  );
}
